<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <form @submit.prevent="submitForm()">
        <div class="join container">
          <div class="joinTitle">
            <h3>회원탈퇴</h3>
            <p>회원탈퇴를 위해 비밀번호를 입력해주세요.</p>
          </div>
          <div class="joinContext">
            <div class="article require" :class="{errorLaise : form.password.hasError}">
              <div class="inputHeader">
                <p>비밀번호</p>
                <span class="warn"  v-text="form.password.errorTxt" v-if="form.password.hasError"></span>
              </div>
              <input type="password" v-model="form.password.value" maxlength="20" @keyup="blurPassword()"  placeholder="비밀번호를 입력해주세요."/>
            </div>
          </div>
        </div>
        <div class="btnWrap half" :class="{visible : form.password.flag}">
          <router-link to="/controllSetting">
            <button type="button" class="cancel">취소</button>
          </router-link>
          <button type="submit">회원탈퇴</button>
        </div>
      </form>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet" @causeAction="secession()"/>
  </div>
</template>

<script>
import AppSidebar from '../../components/AppSidebar'
import AppHeader from '../../components/AppHeader'
import AddPopup from '@/components/AddPopup'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        nextLink: '',
        closeType: 'close'
      },
      transDate: {
        headerName: '회원탈퇴',
        prevUrl: '/'
      },
      isChangePw: '',
      form: {
        password: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        }
      },
      setCount: false
    }
  },
  created () {
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
  },
  computed: {
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP',
      'SET_USERNAME'
    ]),
    ...mapMutations('referrer', [
      'SET_REFERRER'
    ]),
    callPrev () {
      if (this.setCount) {
        this.$router.push('/controllSetting')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    },
    blurPassword () {
      this.form.password.flag = false
      this.checkPassword()
    },
    checkPassword () {
      if (this.form.password.flag) return true
      const password = this.form.password.value
      if (password === '') {
        this.form.password.hasError = true
        this.form.password.errorTxt = '비밀번호를 입력해주세요.'
        return false
      }
      // const isPw = /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,20}$/
      // if (!isPw.test(password)) {
      //   this.form.password.hasError = true
      //   this.form.password.flag = false
      //   this.form.password.errorTxt = '비밀번호는 영문대/소문자+숫자 조합으로 8~20자를 설정해주세요.'
      //   return false
      // }
      this.form.password.flag = true
      this.form.password.hasError = false
      this.form.password.errorTxt = ''
      return true
    },
    async submitForm () {
      if (this.form.password.value.replace(/\s/gi, '') === '') {
        this.popupSet.content = '비밀번호를 입력해주세요.'
        this.SET_POPUP(true)
        return false
      }
      try {
        const userData = {
          password: this.form.password.value.replace(/\s/gi, '')
        }
        await this.CHECK_PW_SECESSION(userData)
          .then(() => {
            this.secessionCheck()
          })
      } catch (error) {
        console.log('error :', error);
        console.log('탈퇴 비밀번호 확인 API에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = '비밀번호를 확인해주세요.'
          this.popupSet.count = 'single'
          this.popupSet.confirmBtnText = '확인'
        } else {
          await this.$router.push('/login')
        }
      } finally {
        this.form.password.value = ''
      }
    },
    secessionCheck () {
      this.SET_POPUP(true)
      this.popupSet.count = 'causeActionDouble'
      this.popupSet.content = '회원탈퇴시 이용 가능한 서비스가 제한될 수 있습니다. 정말 탈퇴하시겠습니까?'
      this.popupSet.cancelBtnText = '아니요'
      this.popupSet.confirmBtnText = '네'
    },
    async checkJoinPw () {
    },
    async secession () {
      try {
        await this.SET_REFERRER(window.location.href)
        await this.SECESSION()
      } catch (error) {
        this.SET_POPUP(true)
        this.popupSet.content = error.response.message
        this.popupSet.count = 'another'
        this.popupSet.nextLink = '/'
        this.popupSet.closeType = 'action'
        this.popupSet.closeLink = '/'
      } finally {
      }
    },
    ...mapActions([
      'CHECK_PW_SECESSION',
      'SECESSION'
    ])
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  beforeDestroy () {
    this.setCount = false
  }
}
</script>

<style lang="scss" scoped>
  .join.container .joinTitle {
    margin: 0 0 15px 0;
  }
</style>
